.requirementRow {
    display: flex;
    align-items: baseline;
}

.description {
    margin-top: 20px;
    margin-left: 75px;
}

.hrModifier {
    margin: 0px;
    border: 1px solid var(--hps-blue);
    opacity: 0.06;
}

/* Contains the "Compliance Requirements" header text. */
.headerContainer {
    margin: 10px 0px;
}

.requirementTextContainer {
    display: flex;
    flex: 2 1 auto;
}

.requirementTextContainer {
    flex-direction: column;
    padding: 5px 20px 5px 0px;
}

.requirementStatusContainer {
    display: flex;
    justify-content: center;
    padding: 0px 0px 0px 10px;
    min-width: 40px;
}

/* Contains the "Overall Requirement Status" and "Controls Mapped" elements. */
.overallStatusAndControlsMappedContainer {
    display: flex;
}

/* Contains the "Overall Requirement Status" label and value. */
.overallStatusContainer {
    display: flex;
    flex-direction: column;
}

/* Contains the "Controls Mapped" label and value. */
.controlsMappedContainer {
    display: flex;
    flex-direction: column;
    padding: 0px 0px 0px 30px;
}
